export type Task = {
  action: 'click' | 'scroll' | "show";
  id: string;
  target: string;
  duration: number;
};

export type Tasks = Record<string, Task>;

export type Tool = {
  id: string;
  url: string;
  title: string;
  tasks: Tasks;
  tool_id?: string;
};

export type Tools = Record<string, Tool>;

export type SiteConfig = {
  character: {
    name: string;
  }
  tools: any;
}

export class ActionEvent extends Event {
  data: any = null

  constructor(type: string, data: any = null) {
    super(type)
    this.data = data
  }
}
